module.exports = {
  'O1':'Peripheral vascular system',
  'O2':'Psychiatric ',
  'O3':'Renal  ',
  'O4':'Respiratory ',
  'O5':'Blood',
  'O6':'Dental',
  'O7':'ENT ',
  'O8':'Endocrine ',
  'O9':'Fetus and Infant ',
  'O10':'Gastrointestinal ',
  'O11':'Rheumatology',
  'O12':'Skin',
  'O13':'Heart',
  'O14':'Hepatic',
  'O15':'Immune',
  'O16':'Kintec/Lab Test/Drug Interactions',
  'O17':'Metabolism',
  'O18':'Neurology'
};
